import { useParams } from "@tanstack/react-router"
import type { Scope } from "./connection"

/** The scope of the current route; scoped routes carry it in the path. */
export function useScope(): Scope {
  const { orgId, environmentId } = useParams({ from: "/$orgId/$environmentId" })
  return { orgId, environmentId }
}
